mutation PurchaseOrderAccountingUnstamper(
  $input: PurchaseOrderAccountingUnstamperInput!
) {
  purchaseOrderAccountingUnstamper(input: $input) {
    purchaseOrder {
      id
      _isAccountingEntry
      _isHistory
      _isStampAllowed
      _isUnstampAllowed
      _rowTimestamp
    }
  }
}
